/* unplugin-vue-components disabled */import { render } from "./tracker-slider.vue?vue&type=template&id=2ba2b907&scoped=true"
import script from "./tracker-slider.vue?vue&type=script&lang=js"
export * from "./tracker-slider.vue?vue&type=script&lang=js"

import "./tracker-slider.vue?vue&type=style&index=0&id=2ba2b907&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba2b907"],['__file',"src/pages/pulse/tracker/tracker-slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ba2b907"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ba2b907', __exports__)) {
    api.reload('2ba2b907', __exports__)
  }
  
  module.hot.accept("./tracker-slider.vue?vue&type=template&id=2ba2b907&scoped=true", () => {
    api.rerender('2ba2b907', render)
  })

}


export default __exports__